import { Button, Col, Form, Input, message, Modal, Row, Select, Space, Popconfirm } from "antd";
import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../server";
import { selectFilterOption } from "../../extensions/helper";
import { isMobile } from "../../extensions/design";
import { LogMonitor } from "@/controls";

const VisitCntItem = ({ itemDefault, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState({...itemDefault});
  const [products, setProducts] = useState([{value: itemDefault.productId, label: itemDefault.productName, vid: itemDefault.productVid}]);
  const [users, setUsers] = useState([{value: itemDefault.userId, label: itemDefault.userName}]);
  const [productLoading, setProductLoading] = useState(false);
  const [certificateSendModal, setCertificateSendModal] = useState(false);
  const [certificateSendEmail, setCertificateSendEmail] = useState("");
  /** Не дергать GET /sale/id после старта удаления и при смене строки — сброс ниже */
  const saleFetchSuppressedRef = useRef(false);

  useEffect(() => {
    saleFetchSuppressedRef.current = false;
  }, [itemDefault?.id]);

  useEffect(() => {
    serverFetch("user")
      .then(data => setUsers(data.map(item => ({label: item.name, value: item.id}))))
      .catch(e => message.error(e.userMessage));
  }, [])

  useEffect(() => {
    const baseItem = { ...itemDefault };
    setItem(baseItem);
    form.setFieldsValue(baseItem);

    const saleId = itemDefault?.id;
    if (saleId !== null && saleId !== undefined && !saleFetchSuppressedRef.current) {
      setLoading(true);
      serverFetch(`sale/${saleId}`)
        .then(data => {
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch(e => message.error(e.userMessage))
        .finally(() => setLoading(false));
    }

    setProductLoading(true);
    itemDefault.paid || serverFetch("product")
      .then(data => {
        setProducts(data.map(i => ({value: i.id, label: i.name, price: i.expPrice, vid: i.vid})));
        setProductLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setProductLoading(false);
      });
  }, [itemDefault, form])

  const onSave = () => {
    setLoading(true);
    serverFetch("sale", {method: "PUT", bodyData: item})
      .then(() => {onClose(true); setLoading(false);})
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  const onDelete = () => {
    saleFetchSuppressedRef.current = true;
    setLoading(true);
    serverFetch(`sale/${item.id}`, {method: "DELETE"})
      .then(() => onClose(true))
      .catch(e => {
        saleFetchSuppressedRef.current = false;
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  const onOpenCertificateSend = () => {
    setCertificateSendEmail(item?.email ?? "");
    setCertificateSendModal(true);
  }

  const onCertificateSend = () => {
    if (!item?.id) return;
    setLoading(true);
    const email = certificateSendEmail.trim();
    const query = email ? `?email=${encodeURIComponent(email)}` : "";
    serverFetch(`sale/CertificateSend/${item.id}${query}`, { method: "POST" })
      .then(() => {
        message.success("Сертификат отправлен");
        setCertificateSendModal(false);
      })
      .catch(e => message.error(e.userMessage))
      .finally(() => setLoading(false));
  }

  const onCertificatePrint = () => {
    if (!item?.id) return;
    setLoading(true);
    serverFetch(`sale/CertificatePrint/${item.id}`)
      .then(data => {
        const html = data?.html;
        if (!html) {
          message.error("Не удалось получить шаблон сертификата");
          return;
        }
        const printWindow = window.open("", "_blank");
        if (!printWindow) {
          message.error("Разрешите открытие всплывающих окон для печати");
          return;
        }
        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
      })
      .catch(e => message.error(e.userMessage))
      .finally(() => setLoading(false));
  }

  const onValuesChange = value => {
    if (value.productId) {
      const syma = (value.price - value.price * value.discountPrc / 100) * value.qty;
      const product = products.find(i => i.value === value.productId);
      const price = product?.price ?? 0;
      if (price) value = { ...value, price, syma };
      value = { ...value, productVid: product?.vid };
    }
    const newItem = {...item, ...value};
    setItem(newItem);
    form.setFieldsValue(newItem);
  }

  const isCertificate = item?.productVid === 4;
  const isPaidCertificate = isCertificate && item?.id && Number(item?.paid ?? 0) >= Number(item?.syma ?? 0);

  const divLogMonitor = item?.id ? <LogMonitor vid={4} id={item.id} /> : null;

  const divCertificateSendModal = (
    <Modal
      title="Отправка сертификата"
      open={certificateSendModal}
      onOk={onCertificateSend}
      onCancel={() => setCertificateSendModal(false)}
      okText="Отправить"
      cancelText="Отмена"
      confirmLoading={loading}
    >
      <Input
        placeholder="Email получателя"
        value={certificateSendEmail}
        onChange={e => setCertificateSendEmail(e.target.value)}
      />
    </Modal>
  );

  return !isMobile ?
  <div className="visit-cnt-item">
    <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} colon={false} disabled={loading || item.paid}>
        <Form.Item label="Товар / услуга" name="productId">
          <Select options={products} loading={productLoading} showSearch={!item.paid} filterOption={selectFilterOption}/>
        </Form.Item>
        <Form.Item label="Исполнитель" name="userId"><Select disabled={{isCertificate}} options={users}/></Form.Item>
        <Form.Item label="Цена" className="sport-modal-group-item"><Row>
          <Col span={4}><Form.Item name="price"><Input /></Form.Item></Col>
          <Col span={10}><Form.Item label="Кол." labelCol={{ span: 12 }} wrapperCol={{ span: 12 }} name="qty"><Input /></Form.Item></Col>
          <Col span={10}><Form.Item label="Скидка, %" labelCol={{ span: 12 }} wrapperCol={{ span: 12 }} name="discountPrc"><Input /></Form.Item></Col>
        </Row></Form.Item>
        {isCertificate && (
          <>
            <Form.Item label="Email" name="email"><Input /></Form.Item>
            <Form.Item label="Получатель" name="name"><Input /></Form.Item>
            <Form.Item label="Сообщение" name="message"><Input.TextArea autoSize={{ minRows: 2, maxRows: 5 }} /></Form.Item>
            <Form.Item label="Подпись" name="sign"><Input /></Form.Item>
          </>
        )}
        <Form.Item label="Итого" name="syma" wrapperCol={{ span: 3 }}><Input disabled/></Form.Item>
        {(!item.paid || isPaidCertificate) && <Form.Item label=" ">
          <Space>
            {isPaidCertificate ? <Button onClick={onOpenCertificateSend} disabled={loading}>Отправить</Button> : null}
            {isPaidCertificate ? <Button onClick={onCertificatePrint} disabled={loading}>Печать</Button> : null}
            {!item.paid ? (
              <Popconfirm title="Подтверждение" description="Удалить продажу?" onConfirm={onDelete}>
                <Button>Удалить</Button>
              </Popconfirm>
            ) : null}
            {!item.paid ? <Button onClick={onSave}>Сохранить</Button> : null}
            {divLogMonitor}
            <Button onClick={() => onClose(false)} disabled={loading}>Отмена</Button>
          </Space>
        </Form.Item>}
    </Form>
    {divCertificateSendModal}
  </div> :
    <>
      <Form form={form} colon={false} labelCol={{ flex: "100px" }} wrapperCol={{ flex: "1" }} onValuesChange={onValuesChange} className="client-subitem-sales-content" style={{ paddingTop: "8px" }}>
        <Form.Item label="Товар/услуга" name="productId" >
          <Select style={{ width: "100%" }} options={products} loading={productLoading} showSearch={!item.paid} filterOption={selectFilterOption}/>
        </Form.Item>
        <Form.Item label="Исполнитель" name="userId" >
          <Select disabled={{isCertificate}} options={users} style={{ width: "100%" }} />
        </Form.Item>
        <div className="visit-item-line-double-halfed" >
          <Form.Item label="Цена" name="price"><Input type="number"/></Form.Item>
          <Form.Item labelCol={{ flex: "80px" }} label="Кол-во" name="qty"><Input type="number"/></Form.Item>
        </div>
        <div className="visit-item-line-double-halfed">
          <Form.Item label="Скидка %" name="discountPrc"><Input type="number" /></Form.Item>
          <Form.Item label="Итого" name="syma" labelCol={{ flex: "80px" }} wrapperCol={{ flex: "1" }}><Input type="number" disabled /></Form.Item>
        </div>
        {isCertificate && (
          <>
            <Form.Item label="Email" name="email"><Input type="email" /></Form.Item>
            <Form.Item label="Получатель" name="name"><Input /></Form.Item>
            <Form.Item label="Сообщение" name="message">
              <Input.TextArea autoSize={{ minRows: 2, maxRows: 5 }} />
            </Form.Item>
            <Form.Item label="Подпись" name="sign"><Input /></Form.Item>
          </>
        )}
        <div className="client-item-line-triple-halfed" >
          {isPaidCertificate ? <Button onClick={onOpenCertificateSend}>Отправить</Button> : null}
          {isPaidCertificate ? <Button onClick={onCertificatePrint}>Печать</Button> : null}
          <Popconfirm title="Подтверждение" description="Удалить продажу?" onConfirm={onDelete}
            placement="top" getPopupContainer={(trigger) => trigger.closest('.client-subitem-sales-content')} overlayClassName="centered-popconfirm">
            <Button /* disabled={itmStatusList.status === 1} */>Удалить</Button>
          </Popconfirm>
          <Button onClick={onSave} loading={loading}>Сохранить</Button>
          {divLogMonitor}
          <Button onClick={() => onClose(false)}>Отмена</Button>
        </div>
      </Form>
      {divCertificateSendModal}
    </>

}

export default VisitCntItem;